export const REGISTRATION_FLOW_DEFAULT = "0"
export const REGISTRATION_FLOW_MSD_CTIO = "1"
export const REGISTRATION_FLOW_MSD_VACCINES_ACADEMY = "2"
export const REGISTRATION_FLOW_NOBIVAC_ANIMAL_HEALTH = "3"
export const REGISTRATION_FLOW_MULTIPLE_STREAM = "4"
export const REGISTRATION_FLOW_DUCATI = "5"
export const REGISTRATION_FLOW_UNLIMITED_EPISODES = "6"
export const REGISTRATION_FLOW_DUCATI_GDC2024 = "7"